import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, computed, watch } from "vue";
  import { useStore } from "vuex";
  import { POSITION, useToast } from "vue-toastification";
  import { AnalyticsConversionRateInterface } from "@/types/AnalyticsConversionRateInterface";
  import { formatDateYYYYMMDD } from "@/helpers/date";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ConversionLeads',
  props: {
    startDate: {
      type: String,
      required: true,
    },
    endDate: {
      type: String,
      required: true,
    },
    searchKey: {
      type: Number,
      required: true,
    },
    estateSelected: {
      type: String,
      required: true,
    },
  },
  setup(__props, { expose: __expose }) {
  __expose();

  const props = __props;

  const store = useStore();
  const toast = useToast();
  const loading = ref(false);

  const conversionsLeadsReports = ref<AnalyticsConversionRateInterface[]>([]);

  const landownerId = computed(() => store.state.user.data._id);

  const startDateSelected = computed(() => {
    return formatDateYYYYMMDD(props.startDate);
  });

  const endDateSelected = computed(() => {
    return formatDateYYYYMMDD(props.endDate);
  });

  const estateSelected = computed(() => {
    return props.estateSelected;
  });

  watch(
    () => props.searchKey,
    () => {
      getConversionsRate();
    }
  );

  const getConversionsRate = () => {
    loading.value = true;

    if (landownerId.value) {
      store
        .dispatch("analytics/getLeadsConversions", {
          landownerId: landownerId.value,
          startDate: startDateSelected.value,
          endDate: endDateSelected.value,
          estateSelected: estateSelected.value,
        })
        .then((res) => {
          conversionsLeadsReports.value = res.data;
        })
        .catch((err) => {
          toast.error("Error getting conversions", {
            position: POSITION.TOP_LEFT,
          });
        })
        .finally(() => {
          loading.value = false;
        });
    }
  };

  onMounted(() => {
    getConversionsRate();
  });

const __returned__ = { props, store, toast, loading, conversionsLeadsReports, landownerId, startDateSelected, endDateSelected, estateSelected, getConversionsRate, ref, onMounted, computed, watch, get useStore() { return useStore }, get POSITION() { return POSITION }, get useToast() { return useToast }, get AnalyticsConversionRateInterface() { return AnalyticsConversionRateInterface }, get formatDateYYYYMMDD() { return formatDateYYYYMMDD } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})